import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=260dd2c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260dd2c6"]])

export default __exports__